
import { createContext, useContext, useEffect, useState } from "react";

const ThemeToogleContext = createContext();

export const ThemeToogleProvider = ({ children }) => {
    const [isDark, setIsDark] = useState(false);

    const toggleDarkMode = () => {
        const newMode = !isDark;
        setIsDark(newMode);
        localStorage.setItem('darkMode', newMode.toString());
        document.documentElement.classList.toggle('dark', newMode);
    };

    useEffect(() => {
        const savedMode = localStorage.getItem('darkMode');
        if (savedMode !== null) {
            setIsDark(savedMode === 'true');
            document.documentElement.classList.toggle('dark', savedMode === 'true');
        } else {
            const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            setIsDark(prefersDark);
            document.documentElement.classList.toggle('dark', prefersDark);
        }
    }, [])

    return (
        <ThemeToogleContext.Provider value={{ isDark, toggleDarkMode }}>
            {children}
        </ThemeToogleContext.Provider>
    )
}


export const useThemeToogle = () => {
    const useTheme = useContext(ThemeToogleContext);
    if (!useTheme) {
        throw new Error("useThemeToogle must be used within a ThemeToogleProvider");
    }
    return useTheme;
}